<template>
    <div id="app">
        <notifications group="fs_success" classes="alert alert-success" />
        <notifications group="fs_warning" classes="alert alert-warning" />
        <notifications group="fs_danger"  classes="alert alert-danger"  />
        <notifications group="fs_primary" classes="alert alert-primary" />
        <div>
            <div class="container-fluid">
                <HeaderComponent v-if="!is_home"
                                 :key="header_key"></HeaderComponent>
            </div>
            <div style='overflow:scroll; overflow:visible;'>
				<router-view     :key="main_key"></router-view>
            </div>
            <FooterComponent v-if="!is_home"></FooterComponent>
        </div>
    </div>
</template>


<script>
    import HeaderComponent from "@/components/common/header.vue";
    import FooterComponent from "@/components/common/footer.vue";

    export default {
        name:  'FiledSafely',
        components: {
            HeaderComponent,
            FooterComponent
        },

		data() {
			return {
				header_key: 0,
				main_key: 0,
			};
		},
		
        computed: {
            is_home() {
                var t = localStorage.getItem('api_token');
                return (!t && this.$route.path == '/');
            },
        },
        methods: {
			rerender_header() {
				this.header_key += 1;  
				this.main_key += 1;  
			}
		},
		
        created() {
            console.log('route = ', this.$route);
        },
		
        mounted() {
        }
    };
</script>


<style scoped>
    @import "./assets/css/fontawesome-all.min.css";
    @import "./assets/css/bootstrap.css";
    @import "./assets/css/filedsafely.css";
    /*
    @import "./assets/css/extra.css";
	@import "./assets/css/bootstrap-toggle.min.css";
    @import "./assets/css/box.css";
	*/
	
    .container-fluid {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    .notifications {
        top:     65px !important;
        right:   10px !important;
		height:  auto !important;
    }

    .notification {
        background: none !important;
    }
</style>


<style>
	#app {
		font-family:             'Avenir', Helvetica, Arial, sans-serif;
		/*
		-webkit-font-smoothing:  antialiased;
		-moz-osx-font-smoothing: grayscale;
		*/
		text-align:              center;
		color:                   #000000;
	}	
</style>
